import { forwardRef } from 'react'
import { IconProps } from 'almanac-ui/icons/Types'

export const Error = forwardRef<SVGSVGElement, IconProps>(({ color = 'currentColor', size = 32 }, forwardedRef) => {
  return (
    <svg
      width={size}
      height={size}
      style={{ width: size, height: size }}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={forwardedRef}
    >
      <g clipPath="url(#clip0_7004_869)">
        <path
          d="M21.3969 19.8165L21.3751 20.2757L21.7879 20.4782L23.4379 21.2874L23.9161 21.522L24.2697 21.1236L29.4357 15.302C31.4486 13.0337 30.6127 9.45639 27.8031 8.31485C24.996 7.17435 21.9041 9.15038 21.7602 12.1769L21.3969 19.8165Z"
          fill="#ED847E"
          stroke="#2B2F38"
          strokeWidth="1.4"
        />
        <path
          d="M11.0527 19.8165L11.0746 20.2757L10.6618 20.4782L9.01177 21.2874L8.53351 21.522L8.17995 21.1236L3.01398 15.302C1.00107 13.0337 1.83692 9.45639 4.64658 8.31485C7.45369 7.17435 10.5455 9.15038 10.6895 12.1769L11.0527 19.8165Z"
          fill="#ED847E"
          stroke="#2B2F38"
          strokeWidth="1.4"
        />
        <path
          d="M14.3349 15.9256L14.4931 16.4072H15H16.8738H17.359L17.5293 15.9528L20.2223 8.76682C21.2995 5.89251 19.1746 2.82699 16.1051 2.82701C13.1122 2.82702 10.994 5.75223 11.9278 8.59569L14.3349 15.9256Z"
          fill="#ED847E"
          stroke="#2B2F38"
          strokeWidth="1.4"
        />
        <path
          d="M18.2732 25.486L18.2732 25.486L18.2755 25.4912C18.6452 26.323 19.3778 26.8937 20.3275 27.259C21.2718 27.6223 22.1939 27.6871 23.0244 27.3181C23.8104 26.9688 24.375 26.3828 24.6821 25.5845C24.9893 24.7859 24.962 23.9741 24.6071 23.1925C24.2301 22.3625 23.497 21.7913 22.5466 21.4257C21.6076 21.0645 20.6896 21.0025 19.8606 21.3709C19.0814 21.7171 18.5237 22.3027 18.2178 23.0978C17.9121 23.8926 17.9326 24.7024 18.2732 25.486Z"
          fill="#ED847E"
          stroke="#2B2F38"
          strokeWidth="1.4"
        />
        <path
          d="M14.1764 25.486L14.1764 25.486L14.1741 25.4912C13.8045 26.323 13.0719 26.8937 12.1222 27.259C11.1778 27.6223 10.2557 27.6871 9.42529 27.3181C8.63921 26.9688 8.07461 26.3828 7.76753 25.5845C7.46033 24.7859 7.48762 23.9741 7.84256 23.1925C8.2195 22.3625 8.9526 21.7913 9.90302 21.4257C10.842 21.0645 11.76 21.0025 12.589 21.3709C13.3683 21.7171 13.9259 22.3027 14.2318 23.0978C14.5376 23.8926 14.517 24.7024 14.1764 25.486Z"
          fill="#ED847E"
          stroke="#2B2F38"
          strokeWidth="1.4"
        />
        <path
          d="M13.5899 21.8409L13.5899 21.841L13.5939 21.845C14.2376 22.4886 15.1262 22.7582 16.1438 22.7582C17.1556 22.7582 18.0395 22.4875 18.682 21.845C19.2903 21.2367 19.6068 20.4871 19.6068 19.6318C19.6068 18.7762 19.2899 18.0283 18.678 17.4262C18.0282 16.7869 17.1389 16.517 16.1206 16.517C15.1145 16.517 14.2354 16.7888 13.5939 17.4302C12.991 18.0332 12.6807 18.7799 12.6807 19.6318C12.6807 20.4834 12.9906 21.2318 13.5899 21.8409Z"
          fill="#ED847E"
          stroke="#2B2F38"
          strokeWidth="1.4"
        />
      </g>
      <defs>
        <clipPath id="clip0_7004_869">
          <rect width="32" height="32" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
})

export default Error
